// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"CampsList_pageHeader__xfjHS"};